var Curriculog = Curriculog || {};

Curriculog.HierarchyDropdownView = (function ($, _, Backbone, HierarchyDropdownView) {

	HierarchyDropdownView = Curriculog.DropdownView.extend({
		tagName: 'select',

		initialize: function (options) {
			this.subviews = [];
			this.id = options.id;
			this.entities = options.entities;
			this.access = options.access || 'admin';
			this.attributes = options.attributes;
			this.collection = options.collection || [];
			this.ineligible = options.ineligible || [];
 			this.disableInactive = options.disableInactive || false;
			this.showInactivity = true;
			this.noAvailableOptionsMessage = options.noAvailableOptionsMessage || 'No Options Available';
			this.firstOption = options.firstOption || '';
			this.selectedValue = options.selectedValue || '';
			this.container = document.createDocumentFragment();
			this.render();
		},

		render: function () {
			this.$el.empty();

			if (this.collection.length > 0 && this.ineligible.length < this.entities.length) {
				var rootNodeIDs = this.collection.findRoots(),
				    rootEntities = this.entities.getSortedEntities(rootNodeIDs),
				    depth = 0;

				// Set the disabled propoerty to false on the select element if it was set
				// by renderEmptyList
				this.$el.prop('disabled', false);

				if (this.firstOption) {
					this.createFirstOption();
				}

				for (var i=0; i < rootEntities.length; i++) {
					var currentEntity = rootEntities[i],
					    entity = currentEntity.toJSON(),
					    options = {
					    	depth: depth,
					    	inactiveText: '',
					    	isInactive: (entity.status === 'inactive'),
					    	selectedValue: this.selectedValue,
					        hasChildren: _.isEmpty(this.collection.findChildren(entity.id)) ? false : true,
					    };

					// Only create a dropdown option for inactive entities if on the admin side
					if (this.access === 'admin') {
						options.inactiveText = options.isInactive ? ' (inactive)' : '';
					} else if (options.isInactive) {
						continue;
					}

					this.createNewOption(currentEntity, options);
				}
			} else {
				this.renderEmptyList();
			}

			this.$el.append(this.container);
		},

		createNewOption: function(currentEntity, options) {
			var subView = new Curriculog.HierarchyDropdownItemView({
				entity: currentEntity,
				depth: options.depth,
				ineligible: this.ineligible,
				disableInactive: this.disableInactive,
				inactiveText: options.inactiveText,
				selectedValue: options.selectedValue,
				hasChildren: options.hasChildren,
			});

			var last = $(this.container.appendChild(subView.el));
			this.subviews.push(subView);

			// If creating the first option (value === ''), we do not want to render children
			if (currentEntity.get('value') !== '') {
				this.renderChildren(currentEntity.get('id'), last, options.depth + 1, options.isInactive);
			}
		},

		renderChildren: function (id, last, depth, parentIsInactive) {
			var childIDs = this.collection.findChildren(id);
			var childEntities = this.entities.getSortedEntities(childIDs);

			for (var i=0; i < childEntities.length; i++) {
				var currentEntity = childEntities[i],
				    entity = currentEntity.toJSON(),
				    options = {
				    	depth: depth,
				    	inactiveText: '',
				    	isInactive: parentIsInactive,
				    	selectedValue: this.selectedValue,
				    	hasChildren: _.isEmpty(this.collection.findChildren(entity.id)) ? false : true,
				    };

				// Only create a dropdown option for inactive entities if on the admin side
				if (this.access === 'admin') {
					if (entity.status === 'inactive') {
						options.inactiveText = ' (inactive)';
						options.isInactive = true;
					} else if (parentIsInactive) {
						options.inactiveText = ' (has inactive parent)';
					}
				} else if (entity.status === 'inactive') {
					continue;
				}

				this.createNewOption(currentEntity, options);
			}
		},

		getCurrentSelection: function () {
			return $(this.el).find('option:selected').val();
		},

		createFirstOption: function (options) {
			var model = {},
			    defaults = {
					name: this.firstOption,
					disabled: false,
					value: '',
			    },
			    newOptionOptions = {
					depth: 0,
					inactiveText: '',
					isInactive: false,
					selectedValue: this.selectedValue,
					hasChildren: false,
			    };

			// Add any options missing from the default object and then update any
			// options from the options object
			options = options ? _.extend(_.defaults(defaults, options), options) : defaults;

			model = new Curriculog.CurriculogModel(options);

			this.createNewOption(model, newOptionOptions);
		},

	});
	return HierarchyDropdownView;

})($, _, Backbone, Curriculog.HierarchyDropdownView || {});
